module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "plus.84371aef.svg";